/* Shared purchase contract. Included gifts are fulfilled with the paid bundle;
   archived/free standalone products must never be required to buy a bundle. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var pending = null;
  // A display refresh must not strand a successfully added pack before checkout.
  function refreshCartQuietly() {
    if (!window.AquonCart || typeof window.AquonCart.refresh !== 'function') return Promise.resolve();
    return new Promise(function (resolve) {
      var finished = false;
      var timer = setTimeout(finish, 1500);
      function finish() {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        resolve();
      }
      Promise.resolve().then(function () { return window.AquonCart.refresh(); }).then(finish, finish);
    });
  }
  function tierFor(id) {
    return ((window.AquonBundleFreebies || {}).tiers || []).find(function (t) { return String(t.bundle) === String(id); });
  }
  function build(id, picks) {
    var tier = tierFor(id);
    if (!tier) throw new Error('This bundle is not configured. Please choose another pack.');
    if (tier.available === false) throw new Error('This pack is currently unavailable. Please choose another pack.');
    var total = 0;
    var props = { _aquon_fulfilment: 'bundle-included-v1', 'Included gift': tier.gift };
    picks.forEach(function (p) {
      if (!Number.isSafeInteger(Number(p.variantId)) || Number(p.variantId) <= 0 || !Number.isInteger(p.qty) || p.qty < 1 || !p.name) {
        throw new Error('Please select valid flavours for your pack.');
      }
      var flavour = ((window.AquonBundleFreebies || {}).flavours || []).find(function (f) { return String(f.id) === String(p.variantId); });
      if (!flavour || !flavour.available) throw new Error('This flavour is unavailable. Please choose another flavour.');
      p = Object.assign({}, p, { name: flavour.name });
      total += p.qty;
      props[p.name] = String((Number(props[p.name]) || 0) + p.qty);
      props['_variant_' + p.variantId] = String((Number(props['_variant_' + p.variantId]) || 0) + p.qty);
    });
    if (total !== tier.picks) throw new Error('Please select exactly ' + tier.picks + ' flavour packs.');
    props['Pack contents'] = total + ' × 24 sachets' + (tier.tier === 3 ? ' (includes 1 free pack)' : '');
    return [{ id: Number(tier.bundle), quantity: 1, properties: props }];
  }
  function add(items) {
    // One mutation at a time across the PDP, card picker and sticky controls.
    if (pending) return Promise.reject(new Error('Your pack is being added. Please wait.'));
    pending = fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      // A rate-limit or server error page (HTML, not JSON) must not surface a parse error.
      return r.json().then(function (data) {
        if (!r.ok) throw new Error((data && (data.description || data.message)) || 'Could not add this pack. Please try again.');
        return data;
      }, function () {
        throw new Error('Could not add this pack. Please try again.');
      });
    }).then(function (data) {
      return refreshCartQuietly().then(function () { return data; });
    }).finally(function () { pending = null; });
    return pending;
  }
  function checkout(options) {
    if (window.AquonCheckout && typeof window.AquonCheckout.start === 'function') {
      return window.AquonCheckout.start(options || {});
    }
    window.location.assign(root + 'checkout');
    return Promise.resolve({ provider: 'shopify' });
  }
  function whenIdle() { return pending || Promise.resolve(); }
  function selectionSummary(node, tier, total) {
    if (!node || !tier) return;
    var remaining = Math.max(0, tier.picks - total);
    // tier.contents / tier.extras are locale text derived from the same picks and
    // gift as build() (snippets/bundle-freebies-config.liquid); the old wording is
    // the fallback when a config without them is loaded.
    var contents = tier.contents || ((tier.picks * 24) + ' sachets');
    var extras = tier.extras ? tier.extras + '.' : tier.gift + ' included.';
    node.textContent = tier.price + ' · ' + contents + '. ' + extras + ' ' +
      (remaining ? 'Choose ' + remaining + ' more ' + (remaining === 1 ? 'box.' : 'boxes.') : 'All flavours selected. Ready to buy.');
  }
  window.AquonPurchase = { build: build, add: add, checkout: checkout, whenIdle: whenIdle, tierFor: tierFor, selectionSummary: selectionSummary };
})();
